module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4329"
    }
  }, [_c('i', [_vm._v("[T]hat joy of living which was . . . so conspicuous a trait [in Chesterton]."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d1",
      "id": "a1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e4449"
    }
  }, [_c('i', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMES")]), _vm._v(" (1936)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4499"
    }
  }, [_c('i', [_vm._v("[Chesterton] for a time cast . . . his shadow over a considerable part of the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d2",
      "id": "a2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e4619"
    }
  }, [_c('i', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMES")]), _vm._v(" (1936)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4669"
    }
  }, [_c('i', [_vm._v("[Chesterton] was in most respects an unusually kind and generous man."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d3",
      "id": "a3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e4799"
    }
  }, [_c('i', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMES")]), _vm._v(" (1987)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4849"
    }
  }, [_c('i', [_vm._v("Chesterton’s writing [is] the only thing that justifies devoting a book to him in the first place. To sort out the good from the bad in his work . . . to characterize his still underrated virtues—his imaginative leaps, his brilliance as an aphorist, the music of his prose at its best . . . "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d4",
      "id": "a4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e5059"
    }
  }, [_c('i', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMES")]), _vm._v(" (1987)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e5109"
    }
  }, [_c('i', [_vm._v("Mr. Chesterton talks about God because God is the most interesting subject for conversation that there is."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d5",
      "id": "a5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e5229"
    }
  }, [_c('i', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMES")]), _vm._v(" (1916)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e5279"
    }
  }, [_c('i', [_vm._v("There have been times when I read a lot of theology. The year I spent in England [after graduation from Harvard] I was very nervous and frightened, standing more or less on the threshold of my adult life and career, if any. One of the ways I assuaged my anxiety was to read a lot of Chesterton and C. S. Lewis."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d6",
      "id": "a6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e5499"
    }
  }, [_c('i', [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PDIKE")]), _vm._v(" (1986)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd1311a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kevi_9781595553836_epub_c5.1_r1.vue
// module id = 72
// module chunks = 0